import { P, Text, useText } from "@sveabank/cc-common";
import { Images } from "../../images";

export const PromoCreditInterest = () => {
	const [t, texts] = useText();

	const text = texts.dashboardPage.promotions.creditInterest;

	return (
		<div className={`bg-promo-gray p-6 max-md:-mx-4`}>
			<div className="tablet:grid-cols-[400px_1fr] grid grid-cols-1 gap-6">
				<div className="tablet:max-w-[400px] w-full">
					<img
						alt={t(text.title)}
						className="h-auto w-full rounded-lg drop-shadow-xs"
						src={Images.PROMO_CREDIT_INTEREST}
					/>
				</div>

				<div className="flex flex-col justify-between gap-2">
					<Text component="h4" bold className="text-text-headline text-xl">
						{t(text.title)}
					</Text>

					<P>{t(text.text)}</P>

					<P className="text-xs">{t(text.notice)}</P>
				</div>
			</div>
		</div>
	);
};
